import { render, staticRenderFns } from "./leaveCreate.vue?vue&type=template&id=e3da1870&"
import script from "./leaveCreate.vue?vue&type=script&lang=js&"
export * from "./leaveCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports